var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-box"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.decyImg)?_c('img',{attrs:{"src":_vm.decyImg,"width":"100%","height":"100%"}}):_vm._e()]),(!_vm.decyImg)?_c('div',{staticClass:"loading_box"},[_c('van-loading',{attrs:{"type":"spinner","size":"20"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }